import i18n from 'i18n'

export const CHOICES = [
  i18n.t('pages.settings.Roles.permissions.no_authority'),
  i18n.t('pages.settings.Roles.permissions.read'),
  i18n.t('pages.settings.Roles.permissions.cru'),
  i18n.t('pages.settings.Roles.permissions.crud'),
  i18n.t('pages.settings.Roles.permissions.execute'),
]
